/**
 * @ngdoc directive
 * @name gazelle.components.grid.directive:gzGrid
 *
 * @description
 *
 * @example
 */

export const name = 'gzGrid';
export default function gzGrid() {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let directive = {
    restrict: 'E',
    scope: {
      gridOptions: '=',
      filters: '=?',
      pairingId: '@',
      filterMode: '=?'
    },
    template: require('./grid.jade'),
    controllerAs: 'vm',
    bindToController: true,
    controller: gzGridController
  };

  return directive;

  /////////////////

  // @ngInject
  function gzGridController(
    $translate,
    $q,
    $timeout,
    $window,
    $scope,
    $rootScope,
    $mdDialog,
    rnPreferences,
    $gzFilters,
    $gzFields,
    rnHttp,
    $mdToast,
    $filter,
    $log,
    $gzAnalytics,
    $sanitize
  ) {
    let vm = this;
    vm.agGridOptions = {
      columnDefs: [],
      onGridReady: agGridReady,
      onModelUpdated: agModelUpdated,
      onColumnVisible: agColumnVisible,
      onColumnPinned: agColumnPinned,
      onColumnMoved: agColumnMoved,
      onDragStopped: agDragStopped,
      onCellClicked: agCellClicked,
      onAfterSortChanged: agAfterSortChanged,
      onColumnResized: agColumnResized,
      onAfterFilterChanged: agAfterFilterChanged,
      headerCellTemplate: require('./grid-header-template.jade'),
      angularCompileHeaders: true,
      angularCompileRows: true,
      headerHeight: 30,
      isExternalFilterPresent: isExternalFilterPresent,
      doesExternalFilterPass: doesExternalFilterPass,
      // Only use mouse events on mobile devices and prevent the filter popup.
      // See https://github.com/ag-grid/ag-grid/issues/1205
      suppressTouch: true,
    };

    const PORTAL_SERVICE_NAME = 'portal_service';
    const FILTERS_PATH = 'filters';

    let data;
    let lastSortModel = [];
    let allowReorder = true;
    let autoColumns = [];
    let identityColumns = [];
    let lastSelection = [];
    let lastColumnIndex = 0;
    let serverFilterAND = true;  // Does the server support AND statements
    let serverFilterOR = false;  // Does the server support OR statements
    let serverFilterRecurse = false; // Does the server support arbitrarily nested logic
    let gridPreferences;
    let columnPrefs;
    let columnOrder;
    let columnSort;
    let selectionDebounceTimer;
    let deselectDebounceTimer;
    let hasServerFilters = false;
    let filters;
    let defaultSort = [];
    let savePreferencesDebounce = _.debounce(savePreferences, 200, {maxWait: 2000, trailing: true});
    let getDataDebounce = _.debounce(getData, 200, {maxWait: 2000, trailing: true});
    let adjustColumnWidthsDebounce = _.debounce(adjustColumnWidths, 100, {maxWait: 300, trailing: true});
    let userFilterChangeListener;
    let namedFilterChangeListener;
    let quickFilterChangeListener;
    let savedFilterAddedListener;
    let lastWidth;
    let lastColumnState = [];
    let gridIndicator = { show: false};
    let drillDownTooltip;
    let expandableRows = false;
    let allowExpandMultiple = false;

    let columnDefs = [];
    let counts = {
      all: undefined,
      serverFilterCount: undefined,
      limit: undefined,
      filterCount: undefined
    };

    vm.loading = true;
    vm.savedFilters = [];
    vm.namedFilters = [];
    vm.isCustomFiltersAvailable = false;

    vm.unitTest = {
      getFilters() {return filters;},
      setFilters(f) {filters = f;},
      setLastSelection(s) {lastSelection = s;},
      setLastSortModel(l) {lastSortModel = l;},
      agGridReady,
      handleUserFilterChanged,
      handleNamedFilterChanged,
      handleQuickFilterChanged,
      handleSavedFilterAdded,
      gzCellRenderer,
      handleQuickFilterText,
      handleCellRenderer,
      selectionChanged,
      isServerSortAffected,
    };

    vm.$onInit = onInit;

    ////////////////
    function onInit() {
      setupGridAPI();
      if (vm.filters) {
        filters = _.cloneDeep(vm.filters);
        if(filters.namedFilters){
          vm.namedFilters = filters.namedFilters;
        }
        $gzFilters.mergeFilters(filters);
      }
      else {
        filters = $gzFilters.createFiltersObject(vm.filters);
      }

      let promises = [];
      promises.push($translate.onReady());
      promises.push(loadPreferences());
      return $q.all(promises).then(() => {
        setupAGGrid();
        let localeText = {
          noRowsToShow: $translate.instant('uxf.uxf.List_NoItems'),
          loadingOoo: $translate.instant('uxf.uxf.List_Loading')
        };
        vm.agGridOptions.localeText = localeText;
        vm.loading = false;
      });
    }

    ///////////////AG-Grid Initialization////////////////////
    ///////////////////////////////////////////////////////
    function agGridReady() {
      let promises = [];
      promises.push($translate.onReady());
      promises.push(loadSavedFilters());
      promises.push(loadPreferences());

      $q.all(promises).then(() => {
        initColumnDefs();
        resetColumns();
        getData(true).then(() => {
          updateQuickFilter();
          $window.addEventListener('resize', handleWindowResized);
          userFilterChangeListener = $rootScope.$on('gzUserFilterChangedEvent', handleUserFilterChanged);
          namedFilterChangeListener = $rootScope.$on('gzNamedFilterChangedEvent', handleNamedFilterChanged);
          quickFilterChangeListener = $rootScope.$on('gzQuickFilterChangedEvent', handleQuickFilterChanged);
          savedFilterAddedListener = $rootScope.$on('gzSavedFilterAddedEvent', handleSavedFilterAdded);

          $scope.$on('$destroy', () => {
            $window.removeEventListener('resize', handleWindowResized);
            userFilterChangeListener();
            namedFilterChangeListener();
            quickFilterChangeListener();
            savedFilterAddedListener();
          });

          updateColumnWidths();
        });
      });
    }

    function initAndResetColumns() {
      initColumnDefs();
      resetColumns();
      updateColumnWidths();
    }

    function updateColumnWidths() {
      $rootScope.$applyAsync(() => {
        autoSizeColumns();
        adjustColumnWidthsDebounce();
      });
    }

    function resetColumns() {
      if (!vm.agGridOptions.api) {
        return;
      }
      vm.agGridOptions.api.setColumnDefs(columnDefs);
      // This needs to happen after columnDefs
      // Check preferences first, then set default sort
      defaultSort = _.get(vm.gridOptions, 'grid.options.defaultSort', []);
      if (columnSort) {
        vm.agGridOptions.api.setSortModel(columnSort);
      }
      else {
        if (defaultSort.length > 0) {
          vm.agGridOptions.api.setSortModel(defaultSort);
        }
      }
    }

    function agModelUpdated() {
      autoSizeColumns();
    }

    function setupGridAPI() {
      vm.gridOptions.api = {
        getData: apiGetData,
        selectRow: apiSelectRow,
        getAGOptions: apiGetAGOptions,
        addOrUpdateRows: apiAddOrUpdateRows,
        removeRows: apiRemoveRows,
      };
    }

    function initColumnDefs() {
      columnDefs = [];
      identityColumns = [];
      autoColumns.splice(0, autoColumns.length);

      if (columnOrder) {
        _.forEach(vm.gridOptions.columns, column => {
          let index = columnOrder.indexOf(column.id);
          if (index < 0) {
            index = 1000;
          }
          _.set(column, 'sortIndex', index);

          if (_.get(column, 'options.isIdentity', false)) {
            identityColumns.push(column);
          }
        });

        vm.gridOptions.sortedColumns = _.sortBy(vm.gridOptions.columns, 'sortIndex');
      }
      else {
        vm.gridOptions.sortedColumns = vm.gridOptions.columns;
      }

      expandableRows = _.get(vm.gridOptions, 'grid.options.expandableRows', false);
      let showExpandIndicator = _.get(vm.gridOptions, 'grid.options.showExpandIndicator', true);
      allowExpandMultiple = _.get(vm.gridOptions, 'grid.options.allowExpandMultiple', false);
      if (expandableRows && showExpandIndicator) {
        columnDefs.push({
          colId: 'gzExpand',
          headerName: '',
          suppressSorting: true,
          suppressMenu: true,
          suppressFilter: true,
          suppressResize: true,
          suppressMovable: true,
          suppressNavigable: true,
          minWidth: 40,
          pinned: 'left',
          width: 40,
          cellRenderer: params => {
            params.$scope.node = params.node;
            params.$scope.expandCollapse = event => {
              event.stopPropagation();
              params.node.expanded = !params.node.expanded;
              if (!allowExpandMultiple) {
                vm.agGridOptions.api.forEachNode(node => {
                  if (node !== params.node) {
                    node.expanded = false;
                  }
                });
              }
              vm.agGridOptions.api.onGroupExpandedOrCollapsed(event.rowIndex);
            };
            return require('./expand-cell.jade');
          },
        });
      }

      _.forEach(vm.gridOptions.sortedColumns, (column) => {
        let columnDef = {colId: column.id};
        setupColumnHeader(column, columnDef);
        setupColumnDefaults(column, columnDef);
        setupColumnOptions(column, columnDef);
        setupCommonCellOptions(column, columnDef);
        setupCellOptions(column, columnDef);
        _.set(columnDef, 'headerCellRenderer', agHeaderCellRenderer);
        _.set(columnDef, 'angularCompileHeaders', true);
        let cellRenderer = _.get(column, 'field.callbacks.cellRenderer');
        if (cellRenderer) {
          _.set(columnDef, 'cellRenderer', handleCellRenderer);
        }
        else {
          _.set(columnDef, 'cellRenderer', gzCellRenderer);
        }

        columnDefs.push(columnDef);
      });

      if (columnDefs.length > 0) {
        lastColumnIndex = columnDefs.length - 1;
      }

      // Add dummy column to extend rows to full width of grid
      columnDefs.push({
        colId: 'gzDummy',
        headerName: '',
        headerCellRenderer: gzDummyHeaderRenderer,
        suppressSorting: true,
        suppressMenu: true,
        suppressFilter: true,
        suppressResize: true,
        suppressMovable: true,
        suppressNavigable: true,
        minWidth: 0
      });
      let gzAction = {
        colId: 'gzAction',
        headerName: '',
        headerCellRenderer: gzActionHeaderRenderer,
        minWidth: 32,
        maxWidth: 32,
        width: 32,
        pinned: 'right',
        suppressSorting: true,
        suppressMenu: true,
        suppressFilter: true,
        suppressResize: true,
        suppressMovable: true,
        suppressNavigable: true
      };
      let allowSelect = _.get(vm.gridOptions, 'grid.options.allowSelect', true);
      let allowMulti = _.get(vm.gridOptions, 'grid.options.allowMultiSelect', false);
      let goto = _.get(vm.gridOptions, 'grid.callbacks.gotoClicked');
      if (allowSelect && !allowMulti && goto !== undefined) {
        drillDownTooltip = $gzFields.resolveString(vm.gridOptions, 'grid.options.drillDownTooltip', undefined);
        gzAction.cellRenderer = gzActionCellRenderer;
      }
      if (_.get(vm.gridOptions, 'grid.options.showActionMenu', true) || _.get(vm.gridOptions, 'grid.callbacks.gotoClicked')) {
        columnDefs.push(gzAction);
        autoColumns.push('gzAction');
      }
    }

    function autoSizeColumns() {
      if (vm.agGridOptions.columnApi) {
        vm.agGridOptions.columnApi.autoSizeColumns(autoColumns);
      }
    }

    function setupAGGrid() {
      _.set(vm.agGridOptions, 'localeText.noRowsToShow', $translate.instant('uxf.uxf.List_NoItems'));
      let allowFilters = _.get(vm.gridOptions, 'grid.options.allowFilters', true);
      _.set(vm.agGridOptions, 'enableFilter', allowFilters);
      // Row Height - default 48px
      let rowHeight = _.get(vm.gridOptions, 'grid.options.rowHeight', 48);
      _.set(vm.agGridOptions, 'rowHeight', rowHeight);

      // Row Selection - default 'single'
      let allowSelect = _.get(vm.gridOptions, 'grid.options.allowSelect', true);
      if (allowSelect) {
        let allowMultiSelect = _.get(vm.gridOptions, 'grid.options.allowMultiSelect', false);
        if (!allowMultiSelect) {
          _.set(vm.agGridOptions, 'rowSelection', 'single');
          _.set(vm.agGridOptions, 'onRowClicked', agRowClicked);
        }
        else {
          _.set(vm.agGridOptions, 'rowSelection', 'multiple');
          _.set(vm.agGridOptions, 'onRowClicked', agRowClicked);
        }
        _.set(vm.agGridOptions, 'rowDeselection', true);
        _.set(vm.agGridOptions, 'onRowSelected', agRowSelected);
        _.set(vm.agGridOptions, 'onRowDoubleClicked', agRowDoubleClicked);
      }

      // Sorting - default true
      let allowSort = _.get(vm.gridOptions, 'grid.options.allowSort', true);
      if (allowSort) {
        _.set(vm.agGridOptions, 'enableSorting', true);
      }

      // Resizing Columns - default true
      let allowResize = _.get(vm.gridOptions, 'grid.options.allowResize', true);
      if (allowResize) {
        _.set(vm.agGridOptions, 'enableColResize', true);
      }

      // Reordering Columns - default true (handled at column level)
      let temp = _.get(vm.gridOptions, 'grid.options.allowReorder', true);
      if (temp) {
        allowReorder = false;
      }

      let allowDragToHide = _.get(vm.gridOptions, 'grid.options.allowDragToHide', true);
      if (!allowDragToHide) {
        vm.agGridOptions.suppressDragLeaveHidesColumns = true;
      }

      // Server supports AND filters - default true
      let serverAND = _.get(vm.gridOptions, 'grid.options.serverFilterAND', true);
      if (serverAND) {
        serverFilterAND = false;
      }

      // Server supports OR filters - default false
      let serverOR = _.get(vm.gridOptions, 'grid.options.serverFilterOR', false);
      if (serverOR) {
        serverFilterOR = true;
      }

      // Server supports Recursive filters - default false
      let serverRecurse = _.get(vm.gridOptions, 'grid.options.serverFilterRecurse', false);
      if (serverRecurse) {
        serverFilterRecurse = true;
      }

      initColumnDefs();

      let identityColumnId = _.get(vm.gridOptions, 'grid.options.identityColumnId');
      if (identityColumnId) {
        let identityColumn = _.find(vm.gridOptions.columns, {id: identityColumnId});
        if (identityColumn) {
          let fieldPath = _.get(identityColumn, 'field.path', identityColumnId);
          _.set(vm.agGridOptions, 'getRowNodeId', data => {
            return _.get(data, fieldPath);
          });
        }
      }
      if (expandableRows) {
        _.set(vm.agGridOptions, 'isFullWidthCell', rowNode => {
          return rowNode.flower;
        });

        _.set(vm.agGridOptions, 'doesDataFlower', rowNode => {
          let isExpandableCallback = _.get(vm.gridOptions, 'grid.callbacks.isRowExpandable');
          if (isExpandableCallback) {
            return isExpandableCallback(rowNode);
          }

          return true;
        });

        _.set(vm.agGridOptions, 'fullWidthCellRenderer', FullWidthCellRenderer);

        let expandHeight = _.get(vm.gridOptions, 'grid.options.expandRowHeight', 50);
        _.set(vm.agGridOptions, 'getRowHeight', params => {
          let isDetailRow = params.node.flower;
          return isDetailRow ? rowHeight + expandHeight : rowHeight;
        });
      }

    }

    function FullWidthCellRenderer() {}

    FullWidthCellRenderer.prototype.init = function(params) {
      var eTemp = document.createElement('div');
      eTemp.innerHTML = this.getTemplate(params);
      this.eGui = eTemp.firstElementChild;

      this.consumeMouseWheelOnCenterText();
    };

    FullWidthCellRenderer.prototype.getTemplate = function(params) {
      // the flower row shares the same data as the parent row
      var data = params.node.data;

      var template = '<div class="gz-grid-expansion-cell"> ERROR - grid.callbacks.getExpandedContent not defined </div>';
      let getContent = _.get(vm.gridOptions, 'grid.callbacks.getExpandedContent');
      if (getContent) {
        template = '<div class="gz-grid-expansion-cell">';
        template += getContent(params);
        template += '</div>';
      }

      return template;
    };

    FullWidthCellRenderer.prototype.getGui = function() {
      return this.eGui;
    };

    // if we don't do this, then the mouse wheel will be picked up by the main
    // grid and scroll the main grid and not this component. this ensures that
    // the wheel move is only picked up by the text field
    FullWidthCellRenderer.prototype.consumeMouseWheelOnCenterText = function() {
      var mouseWheelListener = function(event) {
        event.stopPropagation();
      };

      // event is 'mousewheel' for IE9, Chrome, Safari, Opera
      this.eGui.addEventListener('mousewheel', mouseWheelListener);
      this.eGui.addEventListener('click', mouseWheelListener);
      // event is 'DOMMouseScroll' Firefox
      this.eGui.addEventListener('DOMMouseScroll', mouseWheelListener);
    };

    function setupColumnHeader(column, columnDef) {
      let title = $gzFields.resolveString(column.header, 'title', column.id);
      _.set(column, 'header.title', title);
      let showTitle = _.get(column, 'options.showTitle', true);
      if (column.header.tooltip || column.header.tooltipKey || column.header.tooltipKeyBase) {
        _.set(column, 'header.tooltip', $gzFields.resolveString(column.header, 'tooltip', column.id));
      }
      else if (!showTitle) {
        _.set(column, 'header.tooltip', title);
      }

      _.set(columnDef, 'headerName', column.header.title);
      let fieldPath = _.get(column, 'field.path', null);
      _.set(columnDef, 'field', fieldPath);
      _.set(columnDef, 'suppressSizeToFit', true);
    }

    function setupColumnDefaults(column, columnDef) {
      let columnPreferences = _.get(columnPrefs, column.id);
      let showColumn = _.get(column, 'defaults.show', true);
      let columnWidth = _.get(column, 'defaults.width', 150);
      let pinColumn = _.get(column, 'defaults.pinned');
      let widthFromPreference = false;
      if (columnPreferences) {
        let showPreference = _.get(columnPreferences, 'show');
        if (showPreference !== undefined) {
          showColumn = showPreference;
        }

        let widthPreference = _.get(columnPreferences, 'width');
        if (widthPreference !== undefined) {
          columnWidth = widthPreference;
          widthFromPreference = true;
        }

        let pinnedPreference = _.get(columnPreferences, 'pinned');
        if (pinnedPreference !== undefined) {
          pinColumn = pinnedPreference;
        }
      }

      if (!showColumn) {
        _.set(columnDef, 'hide', true);
      }

      if (pinColumn) {
        _.set(columnDef, 'pinned', pinColumn);
      }

      // Column minWidth - default none
      let minWidth = _.get(column, 'defaults.minWidth', undefined);
      if (minWidth) {
        _.set(columnDef, 'minWidth', minWidth);
      }

      // Column maxWidth - default none
      let maxWidth = _.get(column, 'defaults.maxWidth', undefined);
      if (maxWidth) {
        _.set(columnDef, 'maxWidth', maxWidth);
      }

      // AutoSize - default false
      if (widthFromPreference) {
        _.set(columnDef, 'width', columnWidth);
      }
      else {
        let autoSize = _.get(column, 'defaults.autoSize', false);
        if (autoSize) {
          autoColumns.push(column.id);
        }
        else {
          _.set(columnDef, 'width', columnWidth);
        }
      }
    }

    function setupColumnOptions(column, columnDef) {
      // Show Title - default true
      let showTitle = _.get(column, 'options.showTitle', true);
      if (!showTitle) {
        _.set(columnDef, 'headerName', '');
      }

      // Show Tooltip - default true
      let showTooltip = _.get(column, 'options.showTooltip', true);
      if (!showTooltip) {
        delete columnDef.headerTooltip;
      }

      // Allow Sort - default true
      let allowSort = _.get(column, 'options.allowSort', true);
      if (!allowSort) {
        _.set(columnDef, 'suppressSorting', true);
      }

      // Allow Reorder - default true
      let testReorder = _.get(column, 'options.allowReorder', true);
      if (!allowReorder || !testReorder) {
        _.set(columnDef, 'suppressMoveable', true);
      }

      // Allow Resize - default true
      let allowResize = _.get(column, 'options.allowResize', true);
      if (!allowResize) {
        _.set(columnDef, 'suppressResize', true);
      }

      // Custom Sort Comparator
      let customSort = _.get(column, 'field.callbacks.sortComparator');
      if (customSort) {
        _.set(columnDef, 'comparator', handleSortComparator.bind(null, column));
      }

      // Allow quick filter
      let hideColumn = _.get(columnDef, 'hide', false);
      let allowQuickFilter = _.get(column, 'options.allowQuickFilter', true);
      if (allowQuickFilter) {
        _.set(columnDef, 'getQuickFilterText', handleQuickFilterText);
      }
      else {
        _.set(columnDef, 'getQuickFilterText', () => {
          return null;
        });
      }
    }

    function setupCommonCellOptions(column, columnDef) {
      let cellClasses = [];
      let justify = _.get(column, 'options.justify');
      if (justify) {
        // Use justification if the column specifies
        switch(justify) {
          case 'center':
            cellClasses.push('gz-align-center');
            break;
          case 'right':
            cellClasses.push('gz-align-right');
            break;
        }
      }
      else {
        // If column doesn't override, process default special cases
        let columnType = _.get(column, 'type');
        switch (columnType) {
          case 'number':
            cellClasses.push('gz-align-right');
            break;
          case 'image':
            cellClasses.push('gz-align-center');
            break;
          case 'mapped':
            let showText = _.get(column, 'field.mapped.showText', false);
            if (!showText) {
              cellClasses.push('gz-align-center');
            }
            break;
        }
      }

      // Store this off in the column to use in the class handler
      _.set(column, 'internal.cellClasses', cellClasses);
      _.set(columnDef, 'gzColumn', column);
      _.set(columnDef, 'cellClass', handleCellClass);
    }

    function setupCellOptions(column, columnDef) {
      switch (column.type) {
        case "mapped":
          setupMappedCell(column, columnDef);
          break;
        case "duration":
          setupDurationCell(column, columnDef);
          break;
      }
    }

    function setupMappedCell(column, columnDef) {
      let mappedDisplay = _.get(column, 'field.mapped.display');
      if (mappedDisplay === 'status') {
        _.set(columnDef, 'comparator', defaultStatusComparator);
      }
    }

    function setupDurationCell(column, columnDef) {
      let customSort = _.get(column, 'field.callbacks.sortComparator');
      if (!customSort) {
        _.set(columnDef, 'comparator', defaultDurationComparator.bind(null, column));
      }
    }

    function getData(force = false) {
      let shouldGetData = true;
      let getData = _.get(vm.gridOptions, 'grid.callbacks.getData', undefined);
      let path = _.get(vm.gridOptions, 'grid.path', undefined);
      if (getData) {
        let serverFilters = $gzFilters.getServerFilters(filters, vm.gridOptions);
        if (serverFilters.and.length > 0) {
          hasServerFilters = true;
        }
        else {
          // For now we are optimizing this call out if we didn't have any server filters
          // applied already.  You could argue that we should make sure we have a current
          // data set any time a filter changes
          if (!force && !hasServerFilters) {
            shouldGetData = false;
          }
          hasServerFilters = false;
        }

        if (shouldGetData) {
          vm.agGridOptions.api.showLoadingOverlay();
          let serverSortModel = getServerSort();
          return getData(serverFilters, serverSortModel).then(resp => {
            if (resp) {
              counts = {
                all: undefined,
                serverFilterCount: undefined,
                limit: undefined,
                filterCount: undefined
              };

              if (path) {
                data = _.get(resp, path, []);
              }
              else {
                // If no path provided then we assume we were handed the array
                data = resp;
              }

              // Use vm.counts to initialize if available
              if (vm.counts) {
                counts.limit = vm.counts.limit;
                counts.serverFiltercount = vm.counts.total;
                counts.all = vm.counts.unfilteredTotal;
              }

              // Override counts if they came back with the response
              if (resp.limit !== undefined && resp.limit !== null) {
                counts.limit = resp.limit;
              }

              if (resp.total !== undefined && resp.total !== null) {
                counts.serverFilterCount = resp.total;
              }

              if (resp.unfilteredTotal !== undefined && resp.unfilteredTotal !== null) {
                counts.all = resp.unfilteredTotal;
              }

              if (counts.all === undefined) {
                counts.all = data.length;
              }

              if (counts.serverFilterCount === undefined) {
                counts.serverFilterCount = data.length;
              }

              if (counts.limit === undefined) {
                counts.limit = data.length;
              }

              let getMoreData = _.get(vm.gridOptions, 'grid.callbacks.getMoreData');
              let getMoreAutoMode = _.get(vm.gridOptions, 'grid.options.getMoreAutoMode', false);
              if (counts.serverFilterCount > counts.limit) {
                if (getMoreData && getMoreAutoMode) {
                  // Determine how many pages to get
                  let pages = Math.ceil(counts.serverFilterCount / counts.limit);
                  let promises = [];
                  for (let p = 2; p <= pages; p++) {
                    promises.push(_getMoreData(getMoreData, serverFilters, serverSortModel, p));
                  }

                  $q.all(promises).then(() => {
                    updateGridData();
                  });
                }
                else {
                  $gzAnalytics.event(`Grid (${vm.pairingId}) - Truncated`, {label: `Limit: ${counts.limit}, Count: ${counts.serverFilterCount}`});
                  updateGridData();
                }
              }
              else {
                updateGridData();
              }
             }
          });
        }
        else {
          updateFilters();
        }
      }

      return $q.resolve();
    }

    function _getMoreData(getMoreData, serverFilters, sort, page) {
      let path = _.get(vm.gridOptions, 'grid.path', undefined);
      let identityColumnId = _.get(vm.gridOptions, 'grid.options.identityColumnId');
      let identityColumn;
      let identityDataPath;
      if (identityColumnId) {
        identityColumn = _.find(vm.gridOptions.columns, {id: identityColumnId});
        if (identityColumn) {
          identityDataPath = _.get(identityColumn, 'field.path');
        }
      }
      return getMoreData(serverFilters, sort, page).then(resp => {
        let myData = [];
        if (path) {
          myData = _.get(resp, path, []);
        }
        else {
          myData = resp;
        }

        if (identityDataPath) {
          let addedRows = 0;
          _.forEach(myData, row => {
            let testA = _.get(row, identityDataPath, undefined);
            if (testA) {
              let found = _.find(data, (r) => {
                let testB = _.get(r, identityDataPath);
                if (testB && testA === testB) {
                  return true;
                }
              });

              if (!found) {
                data.push(row);
                addedRows++;
              }
            }
          });

          counts.limit += addedRows;
        }
        else {
          // If we don't have identity we'll concatenate the results
          data = data.concat(myData);
          counts.limit += myData.length;
        }
      });
    }

    function updateGridData() {
      vm.agGridOptions.api.setRowData(data);
      updateFilters();
      $rootScope.$applyAsync(() => {
        handleAfterGetData();
      });
    }

    function handleAfterGetData() {
      let afterGetDataCallback = _.get(vm.gridOptions, 'grid.callbacks.afterGetData');
      if (afterGetDataCallback) {
        afterGetDataCallback();
      }
    }

    function getServerSort() {
      let serverSort = [];
      let sortModel = _.cloneDeep(vm.agGridOptions.api.getSortModel());
      _.forEach(sortModel, item => {
        let column = _.find(vm.gridOptions.columns, {id: item.colId});
        let isServerSort = _.get(column, 'options.sort.isServerSort', false);
        if (isServerSort) {
          serverSort.push(item);
        }
      });

      return serverSort;
    }

    ///////////////GZ-Grid API////////////////////////
    ///////////////////////////////////////////////////////
    function apiGetData() {
      getData(true);
    }

    function apiFindRow(matchCriteria) {
      let foundNode;
      vm.agGridOptions.api.forEachNode(node => {
        for (let propertyName in matchCriteria) {
          let rowValue = _.get(node.data, propertyName);
          let matchValue = _.get(matchCriteria, propertyName);
          if (rowValue !== matchValue) {
            return;
          }
        }
        foundNode = node;
      });

      return foundNode;
    }

    function apiSelectRow(matchCriteria, scrollIntoView=true, selected=true, clearSelection=true) {
      let node = apiFindRow(matchCriteria);
      if (node) {
        node.setSelected(selected, clearSelection);
        if (scrollIntoView) {
          vm.agGridOptions.api.ensureIndexVisible(node.rowIndex);
        }
      }
    }

    function apiGetAGOptions() {
      return vm.agGridOptions;
    }

    function apiAddOrUpdateRows(rows) {
      let identityColumnId = _.get(vm.gridOptions, 'grid.options.identityColumnId');
      if (!rows || !identityColumnId) {
        return false;
      }

      let idColumn = _.find(vm.gridOptions.columns, {id: identityColumnId});
      if (!idColumn) {
        return false;
      }

      let fieldPath = _.get(idColumn, 'field.path', idColumn.id);
      if (!fieldPath) {
        return false;
      }

      let ids = [];
      let mappedRows = {};
      rows.forEach(row => {
        let id = _.get(row, fieldPath);
        if (id) {
          mappedRows[id] = row;
          ids.push(id);
        }
      });

      vm.agGridOptions.api.forEachNode(node => {
        let test = _.get(node.data, fieldPath);
        if (ids.includes(test)) {
          delete node.data.internal.display;
          node.setData(mappedRows[test]);
          delete mappedRows[test];
        }
      });

      let addNodes = Object.values(mappedRows);
      if (addNodes.length > 0) {
        vm.agGridOptions.api.addItems(addNodes);
      }

      vm.agGridOptions.api.onFilterChanged();
      vm.agGridOptions.api.onSortChanged();
    }

    function apiRemoveRows(rowIds) {
      let rowNodes = vm.agGridOptions.api.getModel().rowsToDisplay;
      let removeNodes = [];
      rowIds.forEach(id => {
        let found = rowNodes.find(rn => {
          return rn.id === id;
        });

        if (found) {
          removeNodes.push(found);
        }
      });

      if (removeNodes.length > 0) {
        vm.agGridOptions.api.removeItems(removeNodes);
        agAfterFilterChanged(null);
      }
    }
    ///////////////GZ-Grid Handlers////////////////////////
    ///////////////////////////////////////////////////////
    function handleWindowResized(event) {
      adjustColumnWidthsDebounce();
    }

    function handleUserFilterChanged(event, data) {
      if (vm.agGridOptions.api !== null && data.pairingId === vm.pairingId) {
        filters.userFilter = _.cloneDeep(data.userFilter);
        mergeAndEventFilters(filters);
        getDataDebounce();
      }
    }

    function handleNamedFilterChanged(event, data) {
      if (vm.agGridOptions.api !== null && data.pairingId === vm.pairingId) {
        filters.namedFilter = _.cloneDeep(data.namedFilter);
        if (data.namedFilter) {
          filters.userFilter = {and: []};
        }
        mergeAndEventFilters(filters);
        getDataDebounce();
      }
    }

    function handleQuickFilterChanged(event, data) {
      if (data.pairingId === vm.pairingId) {
        filters.quickFilter = _.cloneDeep(data.quickFilter);
        mergeAndEventFilters(filters);
        updateQuickFilter();
      }
    }

    function handleSavedFilterAdded(event, data){
      if (vm.agGridOptions.api !== null && data.pairingId === vm.pairingId) {
        //Adding the newly added user filter to saved filter so that it should reflect in grid my filter menu
        vm.savedFilters.push(data);
        loadSavedFilters();
      }
    }

    function mergeAndEventFilters(filters) {
      $gzFilters.mergeFilters(filters);
      $rootScope.$emit('gzFiltersChangedEvent', {
        pairingId: vm.pairingId,
        filters: {
          userFilter: filters.userFilter,
          namedFilter: filters.namedFilter,
          quickFilter: filters.quickFilter,
        },
      });
    }

    ///////////////GZ-Cell Renderer///////////////////////
    ///////////////////////////////////////////////////////
    function gzCellRenderer(params) {
      let renderValue = null;
      let column = _.get(params, 'colDef.gzColumn', undefined);
      let value = $gzFields.getValue(params.value, params.data, column, params);
      let classes = [];

      //Store the rendered value in the row for access later
      _.set(params, '$scope.gzColumn.'+column.id, column);
      _.set(params, '$scope.gzValue.'+column.id, params.value);
      _.set(params, 'data.internal.display.' + params.colDef.colId, value);

      let isLinkCallback = _.get(column, 'field.callbacks.isLink', undefined);
      let isActionCallback = _.get(column, 'field.callbacks.isAction', undefined);
      if (value !== null && value !== '' && isLinkCallback && isLinkCallback(params.value, params.data, column)) {
        classes.push('gz-link');
      }
      else if(value !== null && value !== '' && isActionCallback && isActionCallback(params.value, params.data, column)){
        classes.push('gz-action');
      }
      else if (value !== null) {
        classes.push('gz-cell');
      }

      if (value !== null) {
        value = "" + value;
        renderValue = '<div class="';
        _.forEach(classes, myClass => {
          renderValue += myClass + ' ';
        });

        if (column.type === 'string') {
          value = $sanitize(value);
        }

        if ((column.type === 'string' ||
            column.type === 'number' ||
            column.type === 'date' ||
            column.type ==='duration') &&
            value.indexOf('tooltip') === -1) {
          renderValue += '" gz-auto-tooltip>' + value;
        }
        else {
          renderValue += '">'; //close div
          renderValue += value;
        }

        renderValue += '</div>';
      }

      return renderValue;
    }

    ///////////////AG-Grid Handlers////////////////////////
    ///////////////////////////////////////////////////////
    function isExternalFilterPresent() {
      let mergedFilter = _.get(filters, 'mergedFilter.and', []);
      return mergedFilter.length > 0;
    }

    function doesExternalFilterPass(node) {
      let and = _.get(filters, 'mergedFilter.and', []);
      return $gzFilters.evaluateAnd(and, node, vm.gridOptions.columns);
    }

    function agCellClicked(params) {
      let column = _.get(params, 'colDef.gzColumn');
      if (column) {
        //Link click
        let isLinkCallback = _.get(column, 'field.callbacks.isLink');
        if (isLinkCallback && isLinkCallback(params.value, params.data, column)) {
          let gotoLink = _.get(column, 'field.callbacks.gotoLink');
          if (gotoLink) {
            params.event.preventDefault();
            params.event.stopPropagation();
            gotoLink(params.value, params.data, column);
          }
        }

        //Button click
        let isButtonCallback = _.get(column, 'field.callbacks.isAction');
        if(isButtonCallback && isButtonCallback(params.value, params.data, column)) {
          let gotoAction = _.get(column, 'field.callbacks.gotoAction');
          if(gotoAction){
            gotoAction(params.value, params.data, column);
          }
        }
      }
    }

    function agHeaderCellRenderer(params) {
      params.$scope.getSort = getSort;
      params.$scope.getSortIndex = getSortIndex;
      params.$scope.allowFilters = _.get(vm.gridOptions, 'grid.options.allowFilters', true);
      params.$scope.isFiltered = isFiltered;
      params.$scope.isFilter = isFilter;
      params.$scope.openFilter = openFilter;
      params.$scope.headerJustify = _.get(params.colDef.gzColumn, 'options.justify', 'left');


      return require('./grid-header.jade');
    }

    function gzDummyHeaderRenderer() {
      return require('./grid-dummy.jade');
    }

    function gzActionHeaderRenderer(params) {
      params.$scope.showMenu = _.get(vm.gridOptions, 'grid.options.showActionMenu', true);
      params.$scope.gzFilterClicked = gzFilterClicked;
      params.$scope.gzSortClicked = gzSortClicked;
      params.$scope.gzColumnsClicked = gzColumnsClicked;
      params.$scope.gzCSVClicked = gzCSVClicked;
      params.$scope.gzResetSortClicked = gzResetSortClicked;
      params.$scope.gzGridIndicator = gridIndicator;
      params.$scope.gzResetClicked = gzResetClicked;
      params.$scope.gzSaveFilterClicked = gzSaveFilterClicked;
      params.$scope.gzNamedFilterClicked = gzNamedFilterClicked;
      params.$scope.gzRemoveFilterClicked = gzRemoveFilterClicked;
      params.$scope.gzRemoveBuiltInFilterClicked = gzRemoveBuiltInFilterClicked;
      params.$scope.gzShowSort = gzShowSort;
      return require('./grid-menu.jade');
    }

    function gzActionCellRenderer(params) {
      params.$scope.isRowSelected = isRowSelected;
      params.$scope.drillDownClicked = drillDownClicked;
      params.$scope.drillDownTooltip = drillDownTooltip;

      let gotoDisabled = _.get(vm.gridOptions, 'grid.callbacks.gotoDisabled');
      if (gotoDisabled) {
        params.$scope.gotoDisabled = gotoDisabled;
      }

      return require('./grid-action-cell.jade');
    }

    function handleQuickFilterText(params) {
      if (_.get(params, 'colDef.hide', false)) {
        return null;
      }

      let column = _.get(params, 'colDef.gzColumn', undefined);
      let quickFilter = _.get(column, 'field.callbacks.quickFilterText');
      if (quickFilter) {
        return quickFilter(params.value, params.data, column, params);
      }
      else {
        switch(column.type) {
          case 'date':
            return $gzFields.getDateStringValue(params.value, column);
          case 'mapped':
            return $gzFields.getMappedStringValue(params.value, column);
          case 'image':
            return null;
          default:
            let str =_.get(params, 'data.internal.display.' + params.colDef.colId, null);
            if (str === null) {
              str = $gzFields.getValue(params.value, params.data, column, params);
              _.set(params, 'data.internal.display.' + params.colDef.colId, str);
            }
            return '' + str;
        }
      }
    }

    function handleCellClass(params) {
      let column = _.get(params, 'colDef.gzColumn');
      let myClasses = _.get(column, 'internal.cellClasses', []);
      let classRenderer = _.get(vm.gridOptions, 'grid.callbacks.cellClassRenderer');
      let customClasses;
      if (classRenderer) {
        customClasses = classRenderer(params);
      }

      if (customClasses && customClasses.length > 0) {
        customClasses.forEach(cc => {
          if (!myClasses.includes(cc)) {
            myClasses.push(cc);
          }
        });
      }

      return myClasses.length > 0 ? myClasses : null;
    }

    function handleCellRenderer(params) {
      let column = _.get(params, 'colDef.gzColumn');
      let cellRenderer = _.get(column, 'field.callbacks.cellRenderer');
      let value = _.get(params, 'value', null);
      if (cellRenderer) {
        return cellRenderer(value, params.data, column, params);
      }
    }

    function handleSortComparator(column, valueA, valueB, dataA, dataB, isInverted) {
      let customSort = _.get(column, 'field.callbacks.sortComparator');
      if (customSort) {
        return customSort(valueA, valueB, dataA.data, dataB.data, isInverted, column);
      }
    }

    function defaultStatusComparator(valueA, valueB) {
      let compare = getStatusOrdinal(valueA) - getStatusOrdinal(valueB);
      return compare;
    }

    function defaultDurationComparator(column, valueA, valueB, dataA, dataB, isInverted) {
      let valueRenderer = _.get(column, 'field.callbacks.valueRenderer');
      if (valueRenderer) {
        valueA = valueRenderer(null, dataA.data, column);
        valueB = valueRenderer(null, dataB.data, column);
      }

      return valueA - valueB;
    }

    function agRowClicked(event) {
      let isMultiselect = _.get(vm.gridOptions, 'grid.options.allowMultiSelect');
      if (isMultiselect) {
        if (!event.event.ctrlKey && !event.event.shiftKey) {
          if (event.node.isSelected()) {
            //deselectAll
            vm.agGridOptions.api.deselectAll();
            // deselectDebounceTimer = $timeout(deselectRow, 100, true, event);
          }
          else {
            //deselectAll
            vm.agGridOptions.api.deselectAll();
            //Select node
            event.node.setSelected(true);
          }
        }
      }
      else {
        if (event.node.isSelected()) {
          deselectDebounceTimer = $timeout(deselectRow, 100, true, event);
        }
      }

      let expandOnSelect = _.get(vm.gridOptions, 'grid.options.expandOnSelect', true);
      if (expandableRows && expandOnSelect) {
        event.node.expanded = !event.node.expanded;
        if (!allowExpandMultiple) {
          vm.agGridOptions.api.forEachNode(node => {
            if (node !== event.node) {
              node.expanded = false;
            }
          });
        }
        vm.agGridOptions.api.onGroupExpandedOrCollapsed(event.rowIndex);
      }

      // if (isMultiselect && ev
    }

    function agRowDoubleClicked(event) {
      $gzAnalytics.eventClick(`Grid (${vm.pairingId}) - Row double clicked`);
      if (deselectDebounceTimer) {
        $timeout.cancel(deselectDebounceTimer);
      }
      if (selectionDebounceTimer) {
        $timeout.cancel(selectionDebounceTimer);
      }

      let rowDoubleClicked = _.get(vm.gridOptions, 'grid.callbacks.rowDoubleClicked');
      if (rowDoubleClicked) {
        rowDoubleClicked(event.data);
      }
    }

    function agAfterSortChanged(event) {
      let shouldGetData = false;
      if (counts && counts.serverFilterCount > counts.limit) {
        shouldGetData = isServerSortAffected();
      }

      lastSortModel = vm.agGridOptions.api.getSortModel();
      gridIndicator.show = false;
      if (lastSortModel.length === 0) {
        let defaultSortColumnHidden = false;
        let columnState = vm.agGridOptions.columnApi.getColumnState();
        _.forEach(defaultSort, sort => {
          let found = _.find(columnState, {colId: sort.colId});
          if (found && found.hide === true) {
            defaultSortColumnHidden = true;
            return false;
          }
        });

        if (defaultSortColumnHidden) {
          gridIndicator.show = true;
        }
      }
      savePreferencesDebounce();
      $gzAnalytics.eventClick(`Grid (${vm.pairingId}) - Column sorted`, {label: `Sort: ${JSON.stringify(lastSortModel)}`});

      if (shouldGetData) {
        getData(true);
      }
    }

    function isServerSortAffected() {
      let newSortModel = vm.agGridOptions.api.getSortModel();

      let index = 0;
      while (true) {
        if (index >= newSortModel.length) {
          if (index >= lastSortModel.length) {
            return false;
          }

          while (index < lastSortModel.length) {
            let sortItem = lastSortModel[index];
            if (isColumnServerSort(sortItem.colId)) {
              return true;
            }
            ++index;
          }

          return false;
        }

        if (index >= lastSortModel.length) {
          while (index < newSortModel.length) {
            let sortItem = newSortModel[index];
            if (isColumnServerSort(sortItem.colId)) {
              return true;
            }
            ++index;
          }

          return false;
        }

        let lastSortItem = lastSortModel[index];
        let newSortItem = newSortModel[index];
        if (newSortItem.colId !== lastSortItem.colId || newSortItem.sort !== lastSortItem.sort) {
          if (isColumnServerSort(lastSortItem.colId)) {
            return true;
          }
          if (isColumnServerSort(newSortItem.colId)) {
            return true;
          }
        }
        ++index;
      }

      return false;
    }

    function getColumn(colId) {
      return _.find(vm.gridOptions.columns, {id: colId});
    }

    function isColumnServerSort(colId) {
      let column = getColumn(colId);
      if (column) {
        return _.get(column, 'options.sort.isServerSort', false);
      }
      return false;
    }

    function agColumnResized(event) {
      if(event && !event.finished) {
        return;
      }

      if (event.column && event.column.colId !== 'gzDummy' && event.column.colId !== 'gzAction' && event.column.colId !== 'gzExpand') {
        autoColumns.splice(autoColumns.indexOf(event.column.colId), 1);
        $gzAnalytics.eventClick(`Grid (${vm.pairingId}) - Column resized`, {label: `ColId: ${event.column.colId}, type: manual`});
      }

      adjustColumnWidthsDebounce();
    }

    function agAfterFilterChanged(event) {
      $timeout(() => {
        if (!_.get(vm, 'agGridOptions.api')) {
          return;
        }

        counts.filterCount = vm.agGridOptions.api.getModel().rowsToDisplay.length;
        $rootScope.$emit('gzFilterCountUpdated', {
          pairingId: vm.pairingId,
          counts: counts
        });
      }, 200);
    }

    function agColumnVisible(event) {
      savePreferencesDebounce();
      adjustColumnWidthsDebounce();
    }

    function agColumnPinned(event) {
      savePreferencesDebounce();
      adjustColumnWidthsDebounce();
    }

    function agColumnMoved(event) {
      $gzAnalytics.eventClick(`Grid (${vm.pairingId}) - Column moved`, {label: `ColId: ${event.column.colId}, moved to order: ${event.toIndex}`});
      event.toIndex = 0;
      adjustColumnWidthsDebounce();
    }

    function agDragStopped(event) {
      let columnStates = vm.agGridOptions.columnApi.getColumnState();
      if ((expandableRows && columnStates[0] !== 'gzExpand') || columnStates[columnStates.length - 1].colId !== 'gzAction' || columnStates[columnStates.length - 2].colId !== 'gzDummy') {
        let dummyColumnState = _.find(columnStates, {colId: 'gzDummy'});
        let actionColumnState = _.find(columnStates, {colId: 'gzAction'});
        let expandColumnState = _.find(columnStates, {colId: 'gzExpand'});
        let reOrdered = [];
        if (expandColumnState) {
          reOrdered.push(expandColumnState);
        }
        _.forEach(columnStates, columnState => {
          if (columnState.colId !== 'gzDummy' && columnState.colId !== 'gzAction' && columnState.colId !== 'gzExpand') {
            reOrdered.push(columnState);
          }
        });

        if (dummyColumnState) {
          reOrdered.push(dummyColumnState);
        }
        if (actionColumnState) {
          reOrdered.push(actionColumnState);
        }
        vm.agGridOptions.columnApi.setColumnState(reOrdered);
      }

      let columns = vm.agGridOptions.columnApi.getAllColumns();
      _.forEach(columns, column => {
        if (column.colId !== 'gzAction' && column.pinned === 'right') {
          vm.agGridOptions.columnApi.setColumnPinned(column.colId, null);
        }
      });
      adjustColumnWidthsDebounce();
    }

    function agRowSelected(event) {
      if (selectionDebounceTimer) {
        $timeout.cancel(selectionDebounceTimer);
      }
      selectionDebounceTimer = $timeout(selectionChanged, 100);
    }

    function selectionChanged() {
      if (!vm.agGridOptions.api) {
        return;
      }

      selectionDebounceTimer = undefined;
      let selectionChanged = _.get(vm.gridOptions, 'grid.callbacks.selectionChanged');
      if (selectionChanged) {
        let allNodes = vm.agGridOptions.api.getModel().rowsToDisplay;
        let selectedNodes = allNodes.filter(node => {
          return node.selected;
        });
        let currentSelection = selectedNodes.map(node => {
          return node.data;
        });

        let addedRows = [];
        let removedRows = [];
        if (identityColumns.length > 0) {
          _.forEach(lastSelection, row => {
            if (!containsRow(currentSelection, row)) {
              removedRows.push(row);
            }
          });

          _.forEach(currentSelection, row => {
            if (!containsRow(lastSelection, row)) {
              addedRows.push(row);
            }
          });
        }

        selectionChanged(currentSelection, addedRows, removedRows);
        lastSelection = currentSelection;
      }
    }

    function containsRow(rows, test) {
      // If we don't have anything to match on we'll assume no match
      if (identityColumns.length === 0) {
        return false;
      }

      let rowContainsTest = false;
      _.forEach(rows, row => {
        let matchAllColumns = true;
        _.forEach(identityColumns, column => {
          let path = _.get(column, 'field.path');
          if (_.get(row, path) !== _.get(test, path)) {
            matchAllColumns = false;
            return false;
          }
        });

        if (matchAllColumns) {
          rowContainsTest = true;
          return false;
        }
      });

      return rowContainsTest;
    }
    ///////////////AG-Header Controller////////////////////
    ///////////////////////////////////////////////////////
    function getSort(colId) {
      let sort = vm.agGridOptions.api.getSortModel();
      if (sort.length === 0) {
        return;
      }

      let found = _.find(sort, {colId: colId});
      if (!found) {
        return;
      }
      return found.sort;
    }

    function getSortIndex(colId) {
      let sort = vm.agGridOptions.api.getSortModel();
      if (sort.length === 0 || sort.length === 1) {
        return;
      }

      let index = _.findIndex(sort, {colId: colId});
      if (index < 0) {
        return;
      }

      return ++index;
    }

    function isFilter(colId) {
      let column = getColumn(colId);
      let isFilter = _.get(column, 'options.allowFilter', true);
      return isFilter;
    }

    function isFiltered(colId) {
      let and = _.get(filters, 'mergedFilter.and');
      let found = _.find(and, item => {
        return (item.columnId === colId || (item.or && item.or[0].columnId === colId) || (item.and && item.and[0].columnId === colId));
      });

      return found !== undefined;
    }

    function openFilter(event, colId) {
      event.stopPropagation();
      gzFilterClicked(event, colId);
    }

    ///////////////GZ-Action Controller////////////////////
    ///////////////////////////////////////////////////////
    function gzShowSort() {
      if (!vm.gridOptions.allowSort) {
        return false;
      }

      return true;
    }

    function gzFilterClicked($event, colId = undefined) {
      $gzFilters.openFilterDialog(vm.pairingId, vm.gridOptions.columns, filters, colId);
    }

    function gzSortClicked($event) {
      $mdDialog.show({
        targetEvent: $event,
        template: require('./sort/sort-dialog.jade'),
        controller: 'gzSortDialogController',
        bindToController: true,
        controllerAs: 'vm',
        locals: {
          sortModel: vm.agGridOptions.api.getSortModel(),
          columns: vm.gridOptions.columns,
          pairingId: vm.pairingId
        }
      }).then(sortModel => {
        let columnIds = _.map(sortModel, 'colId');
        $gzAnalytics.eventSave(`Grid (${vm.pairingId}) - Sort`, {label: `ColIds: ${JSON.stringify(columnIds)}, Sort: ${JSON.stringify(sortModel)}`});
        vm.agGridOptions.api.setSortModel(sortModel);
        agAfterSortChanged();
      });
    }

    function gzColumnsClicked($event) {
      $mdDialog.show({
        targetEvent: $event,
        template: require('./columns/columns-dialog.jade'),
        controller: 'gzColumnsDialogController',
        controllerAs: 'vm',
        locals: {
          columns: vm.gridOptions.columns,
          pairingId: vm.pairingId
        }
      }).then(prefs => {
        columnPrefs = _.get(prefs, 'columnPrefs');
        columnOrder = _.get(prefs, 'columnOrder');
        initAndResetColumns();
        vm.agGridOptions.api.setSortModel(lastSortModel);
        savePreferencesDebounce();
      });
    }

    function gzResetSortClicked($event) {
      $gzAnalytics.eventClick(`Grid (${vm.pairingId}) - Reset sort`);
      vm.agGridOptions.api.setSortModel(defaultSort);
      savePreferencesDebounce();
    }

    function gzCSVClicked($event) {
      $gzAnalytics.eventClick(`Grid (${vm.pairingId}) - Export CSV`);

      let params = {
        processCellCallback: agCSVExportCellRenderer,
        processHeaderCallback: agCSVExportHeaderRenderer
      };

      //Excluding image column while exporting
      let displayedColumns = vm.agGridOptions.columnApi.getAllDisplayedColumns();
      let hideColumns = [];
      displayedColumns.forEach(col => {
        let allowExport = _.get(col, 'colDef.gzColumn.options.allowExport', true);
        if ((!allowExport || !col.colDef.gzColumn || col.colDef.gzColumn.type === 'image') && col.visible) {
          hideColumns.push(col.colDef.colId);
          vm.agGridOptions.columnApi.setColumnVisible(col.colDef.colId, false);
        }
      });

      vm.agGridOptions.api.exportDataAsCsv(params);

      hideColumns.forEach(colId => {
        vm.agGridOptions.columnApi.setColumnVisible(colId, true);
      });
    }

    function agCSVExportCellRenderer(params) {
      let gzColumn = _.get(params, 'column.colDef.gzColumn');
      if (!gzColumn) {
        return '';
      }
      let exportValue = $gzFields.getExportValue(params.value, params.node.data, params.column.colDef.gzColumn);
      if (exportValue && exportValue.length > 0) {
        const badLeadingChars = ['=', '+', '-', '@'];
        let index = 0;
        while (badLeadingChars.includes(exportValue[index++])) {
        }

        if (index > 0) {
          exportValue = exportValue.substring(index-1);
        }
      }

      return exportValue;
    }

    function agCSVExportHeaderRenderer(params) {
      let gzColumn = _.get(params, 'column.colDef.gzColumn');
      if (!gzColumn) {
        return '';
      }
      return $gzFields.resolveString(params.column.colDef.gzColumn.header, 'title', params.column.colId);
    }

    function gzResetClicked($event) {
      $gzAnalytics.eventClick(`Grid (${vm.pairingId}) - Reset Defaults`);
      rnPreferences.deleteSingle('gzGrid', vm.pairingId).then(() => {
        columnPrefs = undefined;
        columnOrder = undefined;
        loadPreferences().then(() => {
          initAndResetColumns();
          vm.agGridOptions.api.setSortModel(defaultSort);
          savePreferencesDebounce();
        });
      });
    }

    ///////////////AG-Cell Functions///////////////////////
    ///////////////////////////////////////////////////////
    function isRowSelected(rowNode) {
      return rowNode.isSelected();
    }

    function drillDownClicked(rowNode, $event) {
      if ($event) {
        $event.stopPropagation();
      }

      $gzAnalytics.eventClick(`Grid (${vm.pairingId}) - Goto`);
      let goto = _.get(vm.gridOptions, 'grid.callbacks.gotoClicked');
      if (goto) {
        goto(rowNode.data);
      }
    }

    ///////////////GZ-Grid Preferences/////////////////////
    ///////////////////////////////////////////////////////
    function savePreferences() {
      if (!vm.agGridOptions.columnApi) {
        return;
      }

      let columnState = vm.agGridOptions.columnApi.getColumnState();
      let co = [];
      let cp = {};
      let cs = lastSortModel;
      _.forEach(columnState, state => {
        if (state.colId !== 'gzDummy' && state.colId !== 'gzAction' && state.colId !== 'gzExpand') {
          co.push(state.colId);
          let pref = {
            show: !state.hide,
            pinned: state.pinned
          };
          if (autoColumns.indexOf(state.colId) === -1) {
            pref.width = state.width;
          }
          _.set(cp, state.colId, pref);
        }
      });
      let gp = {
        columnOrder: co,
        columnPrefs: cp,
        columnSort: cs
      };
      rnPreferences.setSingleObject('gzGrid', vm.pairingId, gp);
    }

    function loadPreferences() {
      return rnPreferences.getAll().then((prefs) => {
        if (prefs.gzGrid) {
          gridPreferences = rnPreferences.getPrefObjectHelper(prefs, 'gzGrid', vm.pairingId);
          columnPrefs = _.get(gridPreferences, 'columnPrefs');
          columnOrder = _.get(gridPreferences, 'columnOrder');
          columnSort = _.get(gridPreferences, 'columnSort');
        }
      });
    }

    ///////////////Helper Functions////////////////////////
    ///////////////////////////////////////////////////////
    function columnWidthsAreDifferent(columnState, lastColumnState) {
      let isSame = true;
      if (columnState.length !== lastColumnState.length) {
        return false;
      }

      for (let i = 0; i < columnState.length; i++) {
        let testA = columnState[i];
        let testB = lastColumnState[i];
        if (testA.colId !== testB.colId || testA.hide !== testB.hide || testA.width !== testB.width) {
          isSame = false;
          break;
        }
      }

      return !isSame;
    }

    function adjustColumnWidths(force = false) {
      // Manually adjust dummy column and hide if horizontally scrolling to prevent
      // an issue with ag-grid with a gap appears next to the pinned gzAction column.
      let viewport = document.querySelector(`[pairing-id="${vm.pairingId}"] .ag-body-viewport`);
      if (!viewport) {
        return;
      }

      let width = viewport.getBoundingClientRect().width;
      let scrollWidth = viewport.offsetWidth - viewport.clientWidth;
      width -= scrollWidth;

      let columnState = vm.agGridOptions.columnApi.getColumnState();
      if (force || width !== lastWidth || columnWidthsAreDifferent(columnState, lastColumnState)) {
        // Manually adjust dummy column and hide if horizontally scrolling to prevent
        // an issue with ag-grid with a gap appears next to the pinned gzAction column.

        // store off new viewport width before we start manipulating it
        lastWidth = width;

        columnState.forEach(column => {
          if (column.colId === 'gzDummy' || column.colId === 'gzAction' || column.colId === 'gzExpand' || column.hide || column.pinned) {
            return;
          }
          width -= column.width;
        });

        // Store off new columnState before we potentially trigger new calls to adjustColumnWidths
        lastColumnState = columnState;

        let dummyCol = _.find(columnState, { colId: 'gzDummy' });
        if (width > 0) {
          vm.agGridOptions.columnApi.setColumnWidth('gzDummy', width);
          vm.agGridOptions.columnApi.setColumnVisible('gzDummy', true);
        } else {
          vm.agGridOptions.columnApi.setColumnVisible('gzDummy', false);
        }
      }

      savePreferencesDebounce();
    }

    function updateFilters() {
      if (vm.agGridOptions.api) {
        vm.agGridOptions.api.onFilterChanged();
      }
    }

    function updateQuickFilter() {
      //Sometimes api goes away if we rebuild column definitions
      if (!vm.agGridOptions.api) {
        $timeout(updateQuickFilter, 100);
        return;
      }
      let quickValue = _.get(filters, 'quickFilter.value');
      if (quickValue !== undefined) {
        vm.agGridOptions.api.setQuickFilter(quickValue);
      }
      else {
        vm.agGridOptions.api.setQuickFilter('');
      }
    }

    function deselectRow(event) {
      event.node.setSelected(false);
    }

    function getStatusOrdinal(status) {
      if (status) {
        switch (status.toLowerCase()) {
          case 'info':
            return 1;
          case 'warn':
            return 2;
          case 'error':
            return 3;
          case 'unknown':
            return 4;
        }
      }
      return 0;
    }

    //Grid's server Filters
    function loadSavedFilters(){
      return rnHttp.get(PORTAL_SERVICE_NAME, FILTERS_PATH)
        .then((response) => {
            if(response){
               let myFilters = _.filter(response.data.filters, {pairingId: vm.pairingId});
              //Fix up display
              _.forEach(myFilters, filter => {
                let display = {
                  title: filter.name
                };
                _.set(filter, 'namedFilter.display', display);
              });
              vm.savedFilters = myFilters;
            }
        })
        .catch(error => $log.error('Unable to retrieve saved filter', error));
    }

    function gzSaveFilterClicked($event, filter){
      $gzAnalytics.eventClick(`Grid (${vm.pairingId}) - Saved Filter`, {label: `Filter: ${filter.id}` });
      $rootScope.$emit('gzNamedFilterChangedEvent', {
        pairingId: vm.pairingId,
        namedFilter: filter.namedFilter
      });

      if(filter.quickFilter){
        $rootScope.$emit('gzQuickFilterChangedEvent', {
          pairingId: vm.pairingId,
          quickFilter: filter.quickFilter,
          force: true
        });
      }
    }

    function gzNamedFilterClicked($event, filter){
      $gzAnalytics.eventClick(`Grid (${vm.pairingId}) - Named Filter`, {label: `Filter: ${filter.id}` });
      $rootScope.$emit('gzNamedFilterChangedEvent', {
        pairingId: vm.pairingId,
        namedFilter: filter
      });
    }

    function gzRemoveFilterClicked($event, filter){
      $event.stopPropagation();
      if(filter && filter.id){
        rnHttp.delete(PORTAL_SERVICE_NAME, FILTERS_PATH+'/'+filter.id).then(() => {
          _.remove(vm.savedFilters, {id: filter.id});

          let message = filter.name + ' '+ $filter('translate')('uxf.uxf.Filter_Removed');
          $mdToast.showSimple(message);
          $gzAnalytics.eventDelete(`Grid (${vm.pairingId}) - Filter`, {label: `Filter: ${filter.name}`}) ;
        });
      }
    }

    function gzRemoveBuiltInFilterClicked($event, filter){
      if(filter && filter.id){
        $rootScope.$emit('gzFilterRemovedEvent', {
          pairingId: vm.pairingId,
          filterId: filter.id
        });

        $rootScope.$emit('gzNamedFilterChangedEvent', {
          pairingId: vm.pairingId,
          userFilter: filters.namedFilter
        });
      }
    }
  }
}
